// import TabbyTamaraWidget from "../global/TabbyTamaraWidget";
import ShareIcon from "../icons/ShareIcon";
import { useContext, useEffect, useState } from "react";
import BundleProducts from "./BundleProducts";
import { useTranslation } from "next-i18next";
import StarsRateIcon from "../icons/StarsRateIcon";
import Link from "next/link";
import Share from "../share";
import AvailableOffer from "./AvailableOffer";
import Price from "./Price";
import QtyAddToCart from "./QtyAddToCart";
import { getSession, useSession } from "next-auth/react";
import { useRouter } from "next/router";
import ProductConfigurations from "./ProductConfigurations";
import AddToCompare from "./AddToCompare";
import { compareObjects, extractOptionIds } from "@/utils/global";
import InstallmentWidgets from "./installments";
import toast from "react-hot-toast";
import { deleteCookie, getCookie, setCookie } from "cookies-next";
import { ModalContext } from "@/pages/_app";
import { notifyMeOnDrop } from "@/services/global";
import Notify from "../icons/Notify";
import Bundle from "./bundle";
import InfoIcon from "../icons/InfoIcon";

const Details = ({
  product,
  productScore,
  totalReviewsNum,
  relatedProducts,
  setProduct,
  setOpen,
}) => {
  const { t } = useTranslation("product");
  const { locale } = useRouter();
  const { data } = useSession();
  const handshake = getCookie("handshake");

  const [qty, setQty] = useState(1);
  const [pageLoading, setPageLoading] = useState(true);
  const context = useContext(ModalContext);

  useEffect(() => {
    setPageLoading(false);
  }, []);

  // Handling configurable product type
  const isConfigurable = product?.type_id === "configurable";
  const productVariant = !isConfigurable
    ? null
    : product?._configurables?.find((variant) =>
        compareObjects(
          variant?.options,
          extractOptionIds(product?.selectedConfigurations)
        )
      );

  const model =
    product?.name
      ?.at(0)
      .slice(product?.name?.at(0)?.lastIndexOf("(") + 1, -1) || "";

  const isEnabled =
    product?.stock?.qty >= 0 && product?.stock?.is_in_stock == true;

  const handleNotifyMe = async (sku) => {
    const session = await getSession();
    const email = session?.user?.email;
    if (email) {
      const res = await notifyMeOnDrop(handshake, sku, email); // , sku, userId
      // console.log("res/////////// after notifyMeOnDrop", res);
      // res?.data?.data?.success && toast.success(res?.data?.data?.message);
      // res?.data?.data?.success && toast.success(t("You will be reminded when the product is available."));
      res?.data?.data?.success &&
        toast.success(t("You will be reminded if the price drops."));
      deleteCookie("currSku");
      deleteCookie("subscription");
    } else {
      setCookie("currSku", sku);
      setCookie("subscription", "add subscription");
      context?.dispatch({ type: "auth" });
    }
  };

  const textLabels =
    product?.label?.length > 0 &&
    product?.label?.filter(
      (label) =>
        label?.status === "1" &&
        !label?.["frontend_settings"]?.image &&
        !!label?.["frontend_settings"]?.label_text
    );

  return (
    <div className="col-span-full md:col-span-6 *:mb-4">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <h2 className="font-bold rtl:text-start sm:text-[20px] sm:w-3/4">
          {(isConfigurable && productVariant?.name) || product?.name || ""}
        </h2>
        <div className="flex gap-4">
          <div className="*:cursor-pointer max-sm:hidden">
            <Share
              label={<ShareIcon className="cursor-pointer max-sm:hidden" />}
              title={
                (isConfigurable && productVariant?.name) || product?.name || ""
              }
              description={product?.meta_description || ""}
            />
          </div>
          <div className="max-sm:hidden">
            <AddToCompare
              product={product}
              t={t}
              iconClassName="mb-1 size-5"
              fromPDP
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col flex-wrap justify-between gap-3 sm:flex-row sm:items-center">
        <div className="flex items-center gap-4 text-sm max-sm:flex-wrap sm:text-base">
          {product?.option_text_brand ? (
            <>
              <div
                className={`flex items-center gap-2 ${
                  locale === "ar" ? "max-sm:text-[10px] text-sm" : "text-sm"
                }`}
              >
                <span className="font-bold text-zinc-500">
                  {t("Brand")} {":"}
                </span>
                <span className="font-bold whitespace-nowrap">
                  {product?.option_text_brand || ""}
                </span>
              </div>
              <span className="text-emerald-500 "> | </span>
            </>
          ) : null}
          {model ? (
            <>
              <div
                id={"model"}
                className={`flex has-tooltip items-center gap-2 ${
                  locale === "ar" ? "max-sm:text-[10px] text-sm" : "text-sm"
                }`}
              >
                {/* <span class="tooltip bg-blue-500 -mt-12 py-1.5 px-2 text-sm rounded-md text-white">
                  {model}
                </span> */}
                <span className="font-bold text-zinc-500 max-sm:w-12">
                  {t("Model")} {":"}
                </span>
                <span className="w-32 font-bold truncate"> {model} </span>
              </div>
              <span className="text-emerald-500 max-sm:hidden"> | </span>
            </>
          ) : null}
          <div
            className={`flex items-center gap-2 has-tooltip ${
              locale === "ar" ? "max-sm:text-[10px] text-sm" : "text-sm"
            }`}
          >
            {/* <span class="tooltip bg-blue-500 -mt-12 py-1.5 px-2 text-sm rounded-md text-white">
              {(isConfigurable && productVariant?.sku) ||
                (Array.isArray(product?.sku)
                  ? product?.sku?.at(0)
                  : product?.sku) ||
                ""}
            </span> */}
            <span className="font-bold text-zinc-500">
              {t("Sku")} {":"}
            </span>
            <span className="w-32 font-bold truncate">
              {(isConfigurable && productVariant?.sku) ||
                (Array.isArray(product?.sku)
                  ? product?.sku?.at(0)
                  : product?.sku) ||
                ""}
            </span>
          </div>
        </div>
        <p className="text-sm font-bold text-secondary-800 text-start">
          {t("Estimated 2 To 5 Days Delivery")}
        </p>
      </div>

      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <StarsRateIcon rate={productScore} />
          <span className="text-sm font-semibold text-zinc-500">
            {productScore > 0 ? "" : t("No reviews")}
          </span>
          <span className="font-bold max-sm:text-sm">
            {productScore > 0 && `(${productScore})`}
          </span>
        </div>
        {totalReviewsNum > 0 && (
          <Link
            href="#review-summary"
            className="text-xs font-bold underline cursor-pointer text-secondary-800 sm:text-sm"
          >
            {t("View All Ratings")}
          </Link>
        )}
      </div>

      {!isEnabled ? (
        <div
          className={`font-bold text-base flex gap-3 items-center text-red-500 cursor-pointer`}
          onClick={() => handleNotifyMe(product?.sku)}
        >
          <span>{t("Notify Me of Price Drops")}</span>
          <span>
            <Notify />
          </span>
        </div>
      ) : null}

      <Price product={(isConfigurable && productVariant) || product} t={t} />

      {textLabels?.length > 0 && (
        <p className="truncate bg-green-100 text-[10px] sm:text-sm py-1 px-2 w-fit flex items-center gap-2">
          <InfoIcon />
          {textLabels?.[0]?.["frontend_settings"]?.label_text}
        </p>
      )}

      {!pageLoading && (
        <p
          dangerouslySetInnerHTML={{
            __html: product?.additional_html || "",
          }}
          className="*:text-black rtl:text-start border-b pb-2 font-light"
        />
      )}

      <Bundle
        bundleOptions={product?.bundle_product_options}
        bundleInfo={product?.parent_bundle_info}
        locale={locale}
      />

      {!pageLoading && (
        <p
          dangerouslySetInnerHTML={{
            __html:
              (Array.isArray(product?.short_description)
                ? product?.short_description?.join("")
                : product?.short_description
              )?.replaceAll("color: #0000ff", "") || "",
          }}
          className="*:text-black"
        />
      )}

      <div className="flex items-center text-[#4A63A9] gap-3 overflow-x-auto overflow-y-hidden">
        <Link
          href="#product-tab-description"
          className="text-xs font-bold underline cursor-pointer sm:text-sm whitespace-nowrap"
        >
          {t("Descriptions")}
        </Link>
        <span className="block h-3 border border-black"></span>
        <Link
          href="#product-tab-specifications"
          className="text-xs font-bold underline cursor-pointer sm:text-sm whitespace-nowrap"
        >
          {t("Specifications")}
        </Link>
        <span className="block h-3 border border-black"></span>
        <Link
          href="#product-tab-user-reviews"
          className="text-xs font-bold underline cursor-pointer sm:text-sm whitespace-nowrap"
        >
          {t("User Reviews")}
        </Link>
        <span className="block h-3 border border-black"></span>
        <Link
          href="#product-tab-expert-reviews"
          className="text-xs font-bold underline cursor-pointer sm:text-sm whitespace-nowrap"
        >
          {t("Experts Reviews")}
        </Link>
      </div>

      {/* configuration */}
      {product?.type_id == "configurable" && (
        <ProductConfigurations
          product={product}
          setProduct={setProduct}
          t={t}
        />
      )}

      {/* {product?.bundle_discounts.length > 0 && (
        <BundleProducts {...{ product }} />
      )} */}
      {/* {product?.bundle_discounts.length > 0 && (
        <BundleDiscounts {...{ product }} />
      )} */}
      {product?.ulmod_bundles?.length > 0 && (
        <BundleProducts {...{ product, setOpen, t }} />
      )}
      {/* {(product?.eligible_for_tamara || product?.eligible_for_tabby) && (
        <TabbyTamaraWidget
          items={[
            {
              extension_attributes: {
                eligible_for_tamara: product?.eligible_for_tamara || false,
                eligible_for_tabby: product?.eligible_for_tabby || false,
              },
            },
          ]}
          price={product?.prices_with_tax?.price}
        />
      )} */}
      <InstallmentWidgets
        amount={product?.prices_with_tax?.price}
        locale={locale}
        fromPDP
      />
      <AvailableOffer
        t={t}
        groupId={data?.user?.group_id || null}
        freeGifts={product?.free_gifts}
        cartRule={product?.cart_rule}
      />
      <QtyAddToCart
        product={product}
        qty={qty}
        relatedProducts={relatedProducts}
        setQty={setQty}
      />
    </div>
  );
};

export default Details;
